module.exports = __webpack_public_path__ + "static/media/thenNow_icon--active.3090e3b6.svg";